import { useQueryStates, parseAsIndex, parseAsInteger } from 'nuqs'

export const useVndlyPositionIssuesPaginationQueryState = () => {
  const queryStates = useQueryStates(
    {
      pageIndex: parseAsIndex.withDefault(0),
      pageSize: parseAsInteger.withDefault(50),
    },
    {
      urlKeys: {
        pageIndex: 'page',
        pageSize: 'page-size',
      },
    }
  )

  return queryStates
}
